// ==============================================================================================
//  APPLICATION AUTHORSHIP & RIGHTS NOTICE
//
//  Developed by: Gareth Morgan
//  Brand & Product: BuildMyChecks.co.uk
//  Ownership: Sole author and rights holder
//
//  ----------------------------------------------------------------------------------------------
//  NOTICE:
//  - This application and its related systems were designed, developed, and built solely
//    by Gareth Morgan.
//  - Gareth Morgan retains full authorship, intellectual property, and creative rights to
//    all Build My Checks branding, technology, source code, architecture, and design.
//  - No ownership, license, or implied rights are granted to any third party unless
//    explicitly agreed in writing by Gareth Morgan.
//  - Gareth Morgan is NOT responsible for future maintenance, updates, security patching,
//    or operational upkeep if this application is deployed, copied, or modified without
//    his written consent.
//  - Gareth Morgan reserves the right to:
//       • Withdraw or disable access to the application or related services
//       • Remove hosted, cloud-based, or linked services under his control
//       • Revoke access to Build My Checks–related assets, code, APIs, or integrations
//
//  © 2025 Gareth Morgan — BuildMyChecks.co.uk
//  Unauthorized use, alteration, copying, or redistribution without written consent
//  is strictly prohibited.
//
//  ----------------------------------------------------------------------------------------------
//  Build My Checks – ASCII Logo Signature
//  (Symbolic representation of BuildMyChecks.co.uk identity)
//
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................:-==++-.........:-:.............................................
// ...................................-*******:.......=*****+-.........................................
// ...................................=*******+:.....+*******=.........................................
// .........................::........+**********************=.........................................
// .......................-+***+-.:-++***********************=:.......:................................
// .....................-+*************************************+-..=+**+-..............................
// .....................:+*************+=-.............-++***************+:............................
// ......................:+********+=:.....................:=*************=............................
// .......................=******+:...........................-+********+-.............................
// ......................-*****+:...............................-+*****+-..............................
// ................:::::+****+-...................................=*****+..............................
// ...............+-......:=+-........+=.*%=......##:.:::.....:::..-*****=.............................
// ..............=*-*@%%%%@*.........-#*:#@=......@%::@@@*...*@@#...-+++++**++=-.......................
// .............:**-*@*..=@%.=#+..*#=-%#:#@=.=#%#+@%::@%%%-.=@%@#-##:..##:+*****:......................
// ..............-+-*@@%%@%+.+@*..#@==%#:#@==@%-:+@%::@#-@#:%#+%#.+@#.*@+-******=......................
// .................*@*..:#@++@*..#@==%#:#@=+@#...@%::@#.+@%%-=%#..%@#%#:+******+......................
// .................*@%##%@#.-%@%%@@==%#:#@=:#@%#%%%::@#.:#@*.=%#...%@%:=****+-:.......................
// ..................::........::.........:....::.....:....:......:-#@--***+:..........................
// ................:++:+@@@@@*.:@#:.....................#%=......:#%#-.+***+:..........................
// .............-+**+:#@*:.:+%+:@#-=+-...:=+=-....-+=-..#%=.:=-..-++-..+***+:..........................
// .............+***=-@%.......:@@#+#@#.+@#-+%#:+@%++@%:#%+*@#::%#--*-:*****+-.........................
// .............-***=:@%.......:@%:.-%%:%@%%%%%+#@=.....#@@@%:..#%@@%-=**+++++*+.......................
// ..............****-+%@*=+%@*:@%:.-%%.*@*-=*=.*@%==%#:#@+=@%=:++-+@*-+--===:+=.......................
// .................::::=***=:..++..:++..-+**=...:+**+:.=+-.:++:-*#*=::-:+***=::-++:...................
// ....................-****+=............................*#......+*****************=..................
// .....................=*****=.......+##+.:+##=....*+.-#-*#.**:..:+************++*=...................
// .....................+******+-....*%..:.%*.:%+..:%*.=%=*%%*..:--***********+:..-+:..................
// ....................+*********=:%=+%*+%-*%+*%-=#-#%*%@=*#:%*:+****+++****+=...=*****-...............
// ...................=**********+--::.::....::...:..::.:.:-::-:=***+:..=+*+:..:+******-...............
// ....................-******++*******+=-:............-=++****+=+***+:...:...=******+-:...............
// ......................-++-....=+***************************+=+-=****+:...-+******-..................
// ................................=**********************++-:....=******=:+********=..................
// ................................=**********************=......:+*****************+:.................
// ................................+*******=......+*******=........-+=.:=+****+-.-+-...................
// ................................:-=+***-........+******=..............=***+.........................
// .................................................--::...............................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
// ....................................................................................................
//
// ==============================================================================================

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

export default function HowToGuide() {
  const [activeTab, setActiveTab] = useState('web');
  const [webSubTab, setWebSubTab] = useState(activeTab === 'web' ? 'create-account' : 'mobile-getting-started');
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-5xl mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('howToGuide.title')}</h1>
          <p className="text-lg text-gray-600">
            {t('howToGuide.subtitle')}
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex justify-center mb-8 border-b border-gray-200">
          <button
            onClick={() => {
              setActiveTab('web');
              if (webSubTab.startsWith('mobile-')) setWebSubTab('create-account');
            }}
            className={`px-8 py-4 font-semibold text-lg transition-colors border-b-2 ${
              activeTab === 'web'
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            🖥️ {t('howToGuide.webTab')}
          </button>
          <button
            onClick={() => {
              setActiveTab('mobile');
              if (!webSubTab.startsWith('mobile-')) setWebSubTab('mobile-getting-started');
            }}
            className={`px-8 py-4 font-semibold text-lg transition-colors border-b-2 ${
              activeTab === 'mobile'
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            📱 {t('howToGuide.mobileTab')}
          </button>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-md p-8">
          {activeTab === 'web' ? (
            <div>
              {/* Web App Sub-tabs */}
              <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200 pb-4">
                <button
                  onClick={() => setWebSubTab('create-account')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'create-account'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🧾 {t('howToGuide.webTabs.createAccount')}
                </button>
                <button
                  onClick={() => setWebSubTab('manage-users')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'manage-users'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  👥 {t('howToGuide.webTabs.manageUsers')}
                </button>
                <button
                  onClick={() => setWebSubTab('manage-groups')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'manage-groups'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🏷️ {t('howToGuide.webTabs.manageGroups')}
                </button>
                <button
                  onClick={() => setWebSubTab('device-management')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'device-management'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  📱 {t('howToGuide.webTabs.deviceManagement')}
                </button>
                <button
                  onClick={() => setWebSubTab('assets')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'assets'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  📦 {t('howToGuide.webTabs.assets')}
                </button>
                <button
                  onClick={() => setWebSubTab('folders')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'folders'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  📁 {t('howToGuide.webTabs.folders')}
                </button>
                <button
                  onClick={() => setWebSubTab('manage-subscription')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'manage-subscription'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  💳 {t('howToGuide.webTabs.manageSubscription')}
                </button>
                <button
                  onClick={() => setWebSubTab('create-check')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'create-check'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  ✏️ {t('howToGuide.webTabs.createCheck')}
                </button>
                <button
                  onClick={() => setWebSubTab('conduct-check')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'conduct-check'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  ✅ {t('howToGuide.webTabs.conductCheck')}
                </button>
                <button
                  onClick={() => setWebSubTab('schedules-approvals')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'schedules-approvals'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  📅 {t('howToGuide.webTabs.schedulesApprovals')}
                </button>
                <button
                  onClick={() => setWebSubTab('repeatable-sections')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'repeatable-sections'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🔁 {t('howToGuide.webTabs.repeatableSections')}
                </button>
                <button
                  onClick={() => setWebSubTab('control-access')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'control-access'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🔒 {t('howToGuide.webTabs.controlAccess')}
                </button>
                <button
                  onClick={() => setWebSubTab('policies-knowledge-hub')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'policies-knowledge-hub'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  POL {t('howToGuide.webTabs.policiesKnowledgeHub', 'Policies & Knowledge Hub')}
                </button>
                <button
                  onClick={() => setWebSubTab('split-workflow')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'split-workflow'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  WF {t('howToGuide.webTabs.splitWorkflow', 'Split Workflow')}
                </button>
              </div>

              {/* Create Your Account Tab */}
              {webSubTab === 'create-account' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.createAccount.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/Tm1pRrqzj6U"
                        title={t('howToGuide.createAccount.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  {/* Create an Account */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> 🧾 {t('howToGuide.createAccount.sectionTitle')}
                    </h3>
                    <p className="text-gray-700 mb-6">{t('howToGuide.createAccount.sectionDesc')}</p>
                    
                    {/* Step 1 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">1</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.createAccount.step1Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.createAccount.step1Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img 
                              src="/assets/guide/step-1-landing.png" 
                              alt={t('howToGuide.createAccount.step1Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 2 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">2</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.createAccount.step2Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.createAccount.step2Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm max-w-md">
                            <img 
                              src="/assets/guide/step-2-register.png" 
                              alt={t('howToGuide.createAccount.step2Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 3 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">3</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.createAccount.step3Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.createAccount.step3Desc')}</p>
                          <ul className="space-y-2 text-gray-700 ml-4 mb-4">
                            <li>• {t('howToGuide.createAccount.step3Logo')}</li>
                            <li>• {t('howToGuide.createAccount.step3Groups')}</li>
                            <li>• {t('howToGuide.createAccount.step3Users')}</li>
                          </ul>
                          <p className="text-sm text-gray-600 mb-4 italic">💡 {t('howToGuide.createAccount.step3Tip')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img 
                              src="/assets/guide/step-3-company-setup.png" 
                              alt={t('howToGuide.createAccount.step3Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 4 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">4</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.createAccount.step4Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.createAccount.step4Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm max-w-md">
                            <img 
                              src="/assets/guide/step-4-welcome.png" 
                              alt={t('howToGuide.createAccount.step4Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Success Message */}
                    <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <p className="text-green-800 font-semibold">✅ {t('howToGuide.createAccount.successTitle')}</p>
                      <p className="text-green-700 text-sm mt-2">{t('howToGuide.createAccount.successDesc')}</p>
                    </div>
                  </section>
                </div>
              )}

              {/* Add and Manage Users Tab */}
              {webSubTab === 'manage-users' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.manageUsers.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/-TNHLjLEfQY"
                        title={t('howToGuide.manageUsers.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">👥</span> {t('howToGuide.manageUsers.sectionTitle')}
                    </h3>
                    <p className="text-gray-700 mb-6">{t('howToGuide.manageUsers.sectionDesc')}</p>
                    
                    {/* Step 1 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">1</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageUsers.step1Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageUsers.step1Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img 
                              src="/assets/guide/users-step-1-dashboard.png" 
                              alt={t('howToGuide.manageUsers.step1Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 2 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">2</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageUsers.step2Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageUsers.step2Desc')}</p>
                          <ul className="space-y-2 text-gray-700 ml-4 mb-4">
                            <li>• {t('howToGuide.manageUsers.step2Item1')}</li>
                            <li>• {t('howToGuide.manageUsers.step2Item2')}</li>
                            <li>• {t('howToGuide.manageUsers.step2Item3')}</li>
                          </ul>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm max-w-md">
                            <img 
                              src="/assets/guide/users-step-2-add-user.png" 
                              alt={t('howToGuide.manageUsers.step2Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 3 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">3</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageUsers.step3Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageUsers.step3Desc')}</p>
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 ml-4 mb-4 space-y-3">
                            <div>
                              <p className="font-semibold text-gray-800">👑 {t('howToGuide.manageUsers.roleAdmin')}</p>
                              <p className="text-gray-700 text-sm">{t('howToGuide.manageUsers.roleAdminDesc')}</p>
                            </div>
                            <div>
                              <p className="font-semibold text-gray-800">⭐ {t('howToGuide.manageUsers.roleSuperUser')}</p>
                              <p className="text-gray-700 text-sm">{t('howToGuide.manageUsers.roleSuperUserDesc')}</p>
                            </div>
                            <div>
                              <p className="font-semibold text-gray-800">👤 {t('howToGuide.manageUsers.roleUser')}</p>
                              <p className="text-gray-700 text-sm">{t('howToGuide.manageUsers.roleUserDesc')}</p>
                            </div>
                          </div>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img 
                              src="/assets/guide/users-step-3-assign-role.png" 
                              alt={t('howToGuide.manageUsers.step3Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 4 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">4</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageUsers.step4Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageUsers.step4Desc')}</p>
                          <p className="text-gray-700 mb-4"><em>{t('howToGuide.manageUsers.step4Note')}</em></p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img 
                              src="/assets/guide/users-step-4-assign-groups.png" 
                              alt={t('howToGuide.manageUsers.step4Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Success Message */}
                    <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <p className="text-green-800 font-semibold">✅ {t('howToGuide.manageUsers.successTitle')}</p>
                      <p className="text-green-700 text-sm mt-2">{t('howToGuide.manageUsers.successDesc')}</p>
                    </div>
                  </section>
                </div>
              )}

              {/* Manage Groups Tab */}
              {webSubTab === 'manage-groups' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.manageGroups.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/632Yv-yeqwA"
                        title={t('howToGuide.manageGroups.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">🏷️</span> {t('howToGuide.manageGroups.sectionTitle')}
                    </h3>
                    <p className="text-gray-700 mb-6">{t('howToGuide.manageGroups.sectionDesc')}</p>
                    
                    {/* Step 1 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">1</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageGroups.step1Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageGroups.step1Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img 
                              src="/assets/guide/manage-groups-dashboard.png" 
                              alt={t('howToGuide.manageGroups.step1Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 2 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">2</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageGroups.step2Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageGroups.step2Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img 
                              src="/assets/guide/manage-groups-modal.png" 
                              alt={t('howToGuide.manageGroups.step2Alt')} 
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 3 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">3</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageGroups.step3Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageGroups.step3Desc')}</p>
                        </div>
                      </div>
                    </div>

                    {/* Step 4 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">4</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.manageGroups.step4Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.manageGroups.step4Desc')}</p>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              )}

              {/* Device Management Tab */}
              {webSubTab === 'device-management' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.deviceManagement.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/M5j5Bo9zBTQ"
                        title={t('howToGuide.deviceManagement.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.deviceManagement.intro')}</p>

                  {/* Device Limits */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-3 flex items-center gap-2">
                      <span className="text-primary">📱</span> {t('howToGuide.deviceManagement.deviceLimitsTitle')}
                    </h3>
                    <div className="space-y-2 text-gray-700 ml-6">
                      <p>• {t('howToGuide.deviceManagement.deviceLimitsDesc')}</p>
                    </div>
                  </section>

                  {/* Removing Devices */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">🗑️</span> {t('howToGuide.deviceManagement.removingTitle')}
                    </h3>

                    {/* Step 1 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">1</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.deviceManagement.step1Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.deviceManagement.step1Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img
                              src="/assets/guide/device-management-dashboard.png"
                              alt={t('howToGuide.deviceManagement.step1Alt')}
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 2 */}
                    <div className="mb-8 ml-6">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold">2</div>
                        <div className="flex-grow">
                          <h4 className="font-semibold text-gray-800 mb-2">{t('howToGuide.deviceManagement.step2Title')}</h4>
                          <p className="text-gray-700 mb-4">{t('howToGuide.deviceManagement.step2Desc')}</p>
                          <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                            <img
                              src="/assets/guide/device-management-remove-device.png"
                              alt={t('howToGuide.deviceManagement.step2Alt')}
                              className="w-full h-auto"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              )}

              {/* Assets Tab */}
              {webSubTab === 'assets' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.assets.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/dXTGyZ5BHZQ"
                        title={t('howToGuide.assets.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.assets.intro')}</p>

                  {/* Step 1: Open Assets */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.assets.step1Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.assets.step1Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/assets-dashboard.png"
                        alt={t('howToGuide.assets.step1Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 2: Create a New Asset */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.assets.step2Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.assets.step2Desc')}</p>
                    <div className="ml-10 text-gray-700 space-y-1">
                      <p>• {t('howToGuide.assets.step2Type1')}</p>
                      <p>• {t('howToGuide.assets.step2Type2')}</p>
                      <p>• {t('howToGuide.assets.step2Type3')}</p>
                      <p>• {t('howToGuide.assets.step2Type4')}</p>
                      <p>• {t('howToGuide.assets.step2Type5')}</p>
                    </div>
                  </section>

                  {/* Step 3: Add Asset Details */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.assets.step3Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.assets.step3Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/assets-add-details.png"
                        alt={t('howToGuide.assets.step3Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 4: Add Custom Fields */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">4.</span> {t('howToGuide.assets.step4Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.assets.step4Desc')}</p>
                    <div className="ml-10 text-gray-700 space-y-1">
                      <p>• {t('howToGuide.assets.step4Example1')}</p>
                      <p>• {t('howToGuide.assets.step4Example2')}</p>
                      <p>• {t('howToGuide.assets.step4Example3')}</p>
                      <p>• {t('howToGuide.assets.step4Example4')}</p>
                    </div>
                    <p className="text-gray-700 mt-4 ml-6">{t('howToGuide.assets.step4FieldTypesLabel')}</p>
                    <div className="ml-10 text-gray-700 space-y-1">
                      <p>• {t('howToGuide.assets.step4FieldType1')}</p>
                      <p>• {t('howToGuide.assets.step4FieldType2')}</p>
                      <p>• {t('howToGuide.assets.step4FieldType3')}</p>
                      <p>• {t('howToGuide.assets.step4FieldType4')}</p>
                    </div>
                    <p className="text-gray-700 mt-4 ml-6">{t('howToGuide.assets.step4Rename')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mt-4">
                      <img
                        src="/assets/guide/assets-custom-fields.png"
                        alt={t('howToGuide.assets.step4Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 5: Show Asset Fields in Checks */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">5.</span> {t('howToGuide.assets.step5Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.assets.step5Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/assets-show-in-checks.png"
                        alt={t('howToGuide.assets.step5Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                    <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <p className="text-green-800 font-semibold">✅ {t('howToGuide.assets.successTitle')}</p>
                    </div>
                  </section>
                </div>
              )}

              {/* Folders Tab */}
              {webSubTab === 'folders' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.folders.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/wHXqqy2hELk"
                        title={t('howToGuide.folders.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.folders.intro')}</p>

                  {/* Step 1: Open Create a Check */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.folders.step1Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.folders.step1Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/folders-create-check.png"
                        alt={t('howToGuide.folders.step1Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 2: Show Folders */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.folders.step2Title')}
                    </h3>
                    <div className="text-gray-700 ml-6 space-y-2 mb-4">
                      <p>• {t('howToGuide.folders.step2FormFolders')}</p>
                      <p>• {t('howToGuide.folders.step2AssetFolders')}</p>
                    </div>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/folders-show-folders.png"
                        alt={t('howToGuide.folders.step2Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 3: Create a New Folder */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.folders.step3Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.folders.step3Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/folders-create-folder.png"
                        alt={t('howToGuide.folders.step3Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 4: Add Items to a Folder */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">4.</span> {t('howToGuide.folders.step4Title')}
                    </h3>
                    <div className="text-gray-700 ml-6 space-y-2 mb-4">
                      <p>• {t('howToGuide.folders.step4Option1')}</p>
                      <p>• {t('howToGuide.folders.step4Option2')}</p>
                    </div>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/folders-add-to-folder.png"
                        alt={t('howToGuide.folders.step4Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                    <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <p className="text-green-800 font-semibold">✅ {t('howToGuide.folders.successTitle')}</p>
                    </div>
                  </section>
                </div>
              )}

              {/* Manage Subscription Tab */}
              {webSubTab === 'manage-subscription' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.manageSubscription.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/YaOZvZjnoj8"
                        title={t('howToGuide.manageSubscription.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.manageSubscription.intro')}</p>

                  {/* Step 1: Open Manage Subscription */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.manageSubscription.step1Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.manageSubscription.step1Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/subscription-open-manage.png"
                        alt={t('howToGuide.manageSubscription.step1Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 2: Update User Count */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.manageSubscription.step2Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.manageSubscription.step2Desc')}</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-6">
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                        <img
                          src="/assets/guide/subscription-user-count-1.png"
                          alt={t('howToGuide.manageSubscription.step2Alt1')}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                        <img
                          src="/assets/guide/subscription-user-count-2.png"
                          alt={t('howToGuide.manageSubscription.step2Alt2')}
                          className="w-full h-auto"
                        />
                      </div>
                    </div>
                  </section>

                  {/* Step 3: Update Payment Details */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.manageSubscription.step3Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.manageSubscription.step3Desc')}</p>
                  </section>

                  {/* Step 4: Delete Account */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">4.</span> {t('howToGuide.manageSubscription.step4Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.manageSubscription.step4Desc')}</p>
                    <div className="text-gray-700 ml-10 space-y-2 mb-4">
                      <p>• {t('howToGuide.manageSubscription.step4Item1')}</p>
                      <p>• {t('howToGuide.manageSubscription.step4Item2')}</p>
                    </div>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mb-4">
                      <img
                        src="/assets/guide/subscription-delete-account.png"
                        alt={t('howToGuide.manageSubscription.step4Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                    <div className="ml-6 bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                      <p className="text-yellow-800 font-semibold">⚠️ {t('howToGuide.manageSubscription.step4Warning')}</p>
                    </div>
                  </section>
                </div>
              )}

              {/* How to Create a Check and Use Field Types Tab */}
              {webSubTab === 'create-check' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.createCheck.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/IQiZGyg7wDE"
                        title={t('howToGuide.createCheck.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.createCheck.intro')}</p>

                  {/* Step 1: Create a New Check */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.createCheck.step1Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.createCheck.step1Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/create-check-dashboard.png"
                        alt={t('howToGuide.createCheck.step1Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 2: Name the Check */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.createCheck.step2Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.createCheck.step2Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/create-check-name.png"
                        alt={t('howToGuide.createCheck.step2Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 3: Add Fields to the Form */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.createCheck.step3Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.createCheck.step3Desc')}</p>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.createCheck.step3ClickDesc')}</p>
                    <ul className="space-y-2 text-gray-700 ml-10 mb-4">
                      <li>• {t('howToGuide.createCheck.step3Item1')}</li>
                      <li>• {t('howToGuide.createCheck.step3Item2')}</li>
                      <li>• {t('howToGuide.createCheck.step3Item3')}</li>
                      <li>• {t('howToGuide.createCheck.step3Item4')}</li>
                    </ul>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mb-4">
                      <img
                        src="/assets/guide/create-check-add-fields-1.png"
                        alt={t('howToGuide.createCheck.step3Alt1')}
                        className="w-full h-auto"
                      />
                    </div>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/create-check-add-fields-2.png"
                        alt={t('howToGuide.createCheck.step3Alt2')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Field Types Section */}
                  <section className="mb-8">
                    <h3 className="text-3xl font-bold text-gray-900 mb-6 mt-10 flex items-center gap-2">
                      📋 {t('howToGuide.createCheck.fieldTypesTitle')}
                    </h3>

                    {/* Asset Selector */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldAssetSelector')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldAssetSelectorDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldAssetSelectorDesc2')}</p>
                    </div>

                    {/* Attach Media */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldAttachMedia')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldAttachMediaDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldAttachMediaDesc2')}</p>
                    </div>

                    {/* Checkbox */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldCheckbox')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldCheckboxDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldCheckboxDesc2')}</p>
                    </div>

                    {/* Date & Time */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldDateTime')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldDateTimeDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldDateTimeDesc2')}</p>
                    </div>

                    {/* Document Number */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldDocNumber')}</h4>
                      <p className="text-gray-700 mb-4">{t('howToGuide.createCheck.fieldDocNumberDesc1')}</p>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldDocNumberDesc2')}</p>
                      <ul className="space-y-2 text-gray-700 ml-4 mb-4">
                        <li>• {t('howToGuide.createCheck.fieldDocNumberItem1')}</li>
                        <li>• {t('howToGuide.createCheck.fieldDocNumberItem2')}</li>
                      </ul>
                      <p className="text-gray-700 mb-4">{t('howToGuide.createCheck.fieldDocNumberDesc3')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm mb-4">
                        <img
                          src="/assets/guide/field-type-document-number-config.png"
                          alt={t('howToGuide.createCheck.fieldDocNumberAlt1')}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm">
                        <img
                          src="/assets/guide/field-type-document-number-example.png"
                          alt={t('howToGuide.createCheck.fieldDocNumberAlt2')}
                          className="w-full h-auto"
                        />
                      </div>
                    </div>

                    {/* Inspection Location */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldLocation')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldLocationDesc1')}</p>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldLocationDesc2')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldLocationDesc3')}</p>
                    </div>

                    {/* Instruction Block */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldInstruction')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldInstructionDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldInstructionDesc2')}</p>
                    </div>

                    {/* Multiple Choice (Scored) */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldMultipleChoice')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldMultipleChoiceDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldMultipleChoiceDesc2')}</p>
                    </div>

                    {/* Number */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldNumber')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldNumberDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldNumberDesc2')}</p>
                    </div>

                    {/* Section */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldSection')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldSectionDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldSectionDesc2')}</p>
                    </div>

                    {/* Signature */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldSignature')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldSignatureDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldSignatureDesc2')}</p>
                    </div>

                    {/* Slider */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldSlider')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldSliderDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldSliderDesc2')}</p>
                    </div>

                    {/* Text Answer */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldTextAnswer')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldTextAnswerDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldTextAnswerDesc2')}</p>
                    </div>

                    {/* Yes / No */}
                    <div className="mb-8 ml-6 border-l-4 border-primary pl-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('howToGuide.createCheck.fieldYesNo')}</h4>
                      <p className="text-gray-700 mb-2">{t('howToGuide.createCheck.fieldYesNoDesc1')}</p>
                      <p className="text-gray-700">{t('howToGuide.createCheck.fieldYesNoDesc2')}</p>
                    </div>
                  </section>

                  {/* Conditional Logic and Media */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      🔁 {t('howToGuide.createCheck.conditionalTitle')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.createCheck.conditionalDesc')}</p>
                    <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                      <li>• {t('howToGuide.createCheck.conditionalItem1')}</li>
                      <li>• {t('howToGuide.createCheck.conditionalItem2')}</li>
                    </ul>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.createCheck.conditionalExample')}</p>
                    <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                      <li>• {t('howToGuide.createCheck.conditionalExample1')}</li>
                      <li>• {t('howToGuide.createCheck.conditionalExample2')}</li>
                    </ul>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/conditional-logic-example.png"
                        alt={t('howToGuide.createCheck.conditionalAlt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 4: Test the Check */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">4.</span> {t('howToGuide.createCheck.step4Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.createCheck.step4Desc')}</p>
                    <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                      <li>• {t('howToGuide.createCheck.step4Item1')}</li>
                      <li>• {t('howToGuide.createCheck.step4Item2')}</li>
                      <li>• {t('howToGuide.createCheck.step4Item3')}</li>
                    </ul>
                    <p className="text-gray-700 mb-6 ml-6">{t('howToGuide.createCheck.step4MoveNote')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/create-check-live-field-view.png"
                        alt={t('howToGuide.createCheck.step4Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Success Message */}
                  <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                    <p className="text-green-800 font-semibold">✅ {t('howToGuide.createCheck.successTitle')}</p>
                  </div>
                </div>
              )}

              {/* Conduct a Check and View Reports Tab */}
              {webSubTab === 'conduct-check' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.conductCheck.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/VS_sycExQIk"
                        title={t('howToGuide.conductCheck.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-8">{t('howToGuide.conductCheck.intro')}</p>

                  {/* PART 1: CONDUCTING A CHECK */}
                  <div className="mb-12 pb-8 border-b border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('howToGuide.conductCheck.part1Title')}</h2>

                    {/* Step 1: Open the Check */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">1.</span> {t('howToGuide.conductCheck.step1Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step1Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mb-4">
                        <img
                          src="/assets/guide/conduct-check-open-1.png"
                          alt={t('howToGuide.conductCheck.step1Alt1')}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/conduct-check-open-2.png"
                          alt={t('howToGuide.conductCheck.step1Alt2')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 2: Complete the Check */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">2.</span> {t('howToGuide.conductCheck.step2Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step2Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mb-4">
                        <img
                          src="/assets/guide/conduct-check-complete-1.png"
                          alt={t('howToGuide.conductCheck.step2Alt1')}
                          className="w-full h-auto"
                        />
                      </div>
                      <p className="text-gray-700 mb-4 ml-6 mt-4">{t('howToGuide.conductCheck.step2ConditionalNote')}</p>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step2ConditionalExample')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/conduct-check-complete-2.png"
                          alt={t('howToGuide.conductCheck.step2Alt2')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 3: Save or Submit */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">3.</span> {t('howToGuide.conductCheck.step3Title')}
                      </h3>
                      <ul className="space-y-2 text-gray-700 ml-10 mb-4">
                        <li>• {t('howToGuide.conductCheck.step3Item1')}</li>
                        <li>• {t('howToGuide.conductCheck.step3Item2')}</li>
                      </ul>
                      <div className="ml-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                        <p className="text-blue-800">{t('howToGuide.conductCheck.step3DraftNote')}</p>
                      </div>
                    </section>
                  </div>

                  {/* PART 2: VIEWING SUBMITTED REPORTS */}
                  <div className="mb-12 pb-8 border-b border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('howToGuide.conductCheck.part2Title')}</h2>

                    {/* Step 4: Open Reports */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">4.</span> {t('howToGuide.conductCheck.step4Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step4Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/reports-open-reports.png"
                          alt={t('howToGuide.conductCheck.step4Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 5: Quick View a Report */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">5.</span> {t('howToGuide.conductCheck.step5Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step5Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/reports-quick-view.png"
                          alt={t('howToGuide.conductCheck.step5Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 6: View a Full Report */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">6.</span> {t('howToGuide.conductCheck.step6Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step6Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mb-4">
                        <img
                          src="/assets/guide/reports-view-report.png"
                          alt={t('howToGuide.conductCheck.step6Alt1')}
                          className="w-full h-auto"
                        />
                      </div>
                      <p className="text-gray-700 mb-4 ml-6 mt-4">{t('howToGuide.conductCheck.step6Within')}</p>
                      <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                        <li>• {t('howToGuide.conductCheck.step6Item1')}</li>
                        <li>• {t('howToGuide.conductCheck.step6Item2')}</li>
                        <li>• {t('howToGuide.conductCheck.step6Item3')}</li>
                      </ul>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/reports-remediation.png"
                          alt={t('howToGuide.conductCheck.step6Alt2')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>
                  </div>

                  {/* PART 3: REMEDIATION AND SIGN-OFF */}
                  <div className="mb-12 pb-8 border-b border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('howToGuide.conductCheck.part3Title')}</h2>

                    {/* Step 7: Manage Remediation */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">7.</span> {t('howToGuide.conductCheck.step7Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step7Desc1')}</p>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step7Desc2')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/remediation-manage.png"
                          alt={t('howToGuide.conductCheck.step7Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>
                  </div>

                  {/* PART 4: EXPORTING AND DELETING REPORTS */}
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('howToGuide.conductCheck.part4Title')}</h2>

                    {/* Step 8: Export or Delete Reports */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">8.</span> {t('howToGuide.conductCheck.step8Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step8Desc')}</p>
                      <ol className="space-y-2 text-gray-700 ml-10 mb-6">
                        <li>1. {t('howToGuide.conductCheck.step8Item1')}</li>
                        <li>2. {t('howToGuide.conductCheck.step8Item2')}</li>
                        <li>3. {t('howToGuide.conductCheck.step8Item3')}</li>
                      </ol>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.conductCheck.step8AdminNote')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/reports-export-delete.png"
                          alt={t('howToGuide.conductCheck.step8Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Success Message */}
                    <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <p className="text-green-800 font-semibold">✅ {t('howToGuide.conductCheck.successTitle')}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Schedules and Approvals Tab */}
              {webSubTab === 'schedules-approvals' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.schedulesApprovals.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/jNSWwxrjlQ0"
                        title={t('howToGuide.schedulesApprovals.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-8">{t('howToGuide.schedulesApprovals.intro')}</p>

                  {/* PART 1: SCHEDULES */}
                  <div className="mb-12 pb-8 border-b border-gray-300">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                      <span className="text-primary">Part 1:</span> {t('howToGuide.schedulesApprovals.part1Title')}
                    </h2>

                    {/* Step 1: Edit a Check */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">1.</span> {t('howToGuide.schedulesApprovals.step1Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step1Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/schedule-edit-check.png"
                          alt={t('howToGuide.schedulesApprovals.step1Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 2: Open Schedules */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">2.</span> {t('howToGuide.schedulesApprovals.step2Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step2Desc')}</p>
                    </section>

                    {/* Step 3: Add a Schedule */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">3.</span> {t('howToGuide.schedulesApprovals.step3Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step3Desc')}</p>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step3OptionsLabel')}</p>
                      <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                        <li>• {t('howToGuide.schedulesApprovals.step3Hourly')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3Daily')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3Weekly')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3Fortnightly')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3Monthly')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3Every236')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3Yearly')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3Custom')}</li>
                      </ul>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step3AlsoLabel')}</p>
                      <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                        <li>• {t('howToGuide.schedulesApprovals.step3BeforeWindow')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3AfterWindow')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step3NameOptional')}</li>
                      </ul>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mb-4">
                        <img
                          src="/assets/guide/schedule-add-schedule-1.png"
                          alt={t('howToGuide.schedulesApprovals.step3Alt1')}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/schedule-add-schedule-2.png"
                          alt={t('howToGuide.schedulesApprovals.step3Alt2')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 4: Assign Users or Groups */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">4.</span> {t('howToGuide.schedulesApprovals.step4Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step4Desc')}</p>
                      <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                        <li>• {t('howToGuide.schedulesApprovals.step4Item1')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step4Item2')}</li>
                      </ul>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step4Note')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/schedule-assign-users.png"
                          alt={t('howToGuide.schedulesApprovals.step4Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 5: Create the Schedule */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">5.</span> {t('howToGuide.schedulesApprovals.step5Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step5Desc')}</p>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step5Active')}</p>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step5Edit')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/schedule-create-schedule.png"
                          alt={t('howToGuide.schedulesApprovals.step5Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>
                  </div>

                  {/* PART 2: APPROVALS */}
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                      <span className="text-primary">Part 2:</span> {t('howToGuide.schedulesApprovals.part2Title')}
                    </h2>

                    {/* Step 6: Open Approvals */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">6.</span> {t('howToGuide.schedulesApprovals.step6Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step6Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/approval-open-approvals.png"
                          alt={t('howToGuide.schedulesApprovals.step6Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 7: Enable Approval Workflow */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">7.</span> {t('howToGuide.schedulesApprovals.step7Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step7Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/approval-enable-workflow.png"
                          alt={t('howToGuide.schedulesApprovals.step7Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 8: Create Approval Stages */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">8.</span> {t('howToGuide.schedulesApprovals.step8Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step8Desc')}</p>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step8Example')}</p>
                      <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                        <li>• {t('howToGuide.schedulesApprovals.step8Stage1')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step8Stage2')}</li>
                      </ul>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step8ForEach')}</p>
                      <ul className="space-y-2 text-gray-700 ml-10 mb-6">
                        <li>• {t('howToGuide.schedulesApprovals.step8Item1')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step8Item2')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step8Item3')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step8Item4')}</li>
                        <li>• {t('howToGuide.schedulesApprovals.step8Item5')}</li>
                      </ul>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6 mb-4">
                        <img
                          src="/assets/guide/approval-create-stages-1.png"
                          alt={t('howToGuide.schedulesApprovals.step8Alt1')}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/approval-create-stages-2.png"
                          alt={t('howToGuide.schedulesApprovals.step8Alt2')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Step 9: Save the Workflow */}
                    <section className="mb-8">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <span className="text-primary">9.</span> {t('howToGuide.schedulesApprovals.step9Title')}
                      </h3>
                      <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.schedulesApprovals.step9Desc')}</p>
                      <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                        <img
                          src="/assets/guide/approval-save-workflow.png"
                          alt={t('howToGuide.schedulesApprovals.step9Alt')}
                          className="w-full h-auto"
                        />
                      </div>
                    </section>

                    {/* Success Message */}
                    <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <p className="text-green-800 font-semibold">✅ {t('howToGuide.schedulesApprovals.successTitle')}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Repeatable Sections Tab */}
              {webSubTab === 'repeatable-sections' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.repeatableSections.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/kxONO_RZOZw"
                        title={t('howToGuide.repeatableSections.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.repeatableSections.intro')}</p>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.repeatableSections.whatYouLearn')}</h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>• {t('howToGuide.repeatableSections.learn1')}</p>
                      <p>• {t('howToGuide.repeatableSections.learn2')}</p>
                      <p>• {t('howToGuide.repeatableSections.learn3')}</p>
                      <p>• {t('howToGuide.repeatableSections.learn4')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.repeatableSections.useCasesTitle')}</h3>
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded ml-6">
                      <p className="text-gray-700 mb-2"><strong>{t('howToGuide.repeatableSections.useCasesIntro')}</strong></p>
                      <div className="space-y-2 text-gray-700 ml-4 mt-3">
                        <p>• 🧯 {t('howToGuide.repeatableSections.useCase1')}</p>
                        <p>• 🔍 {t('howToGuide.repeatableSections.useCase2')}</p>
                        <p>• 🚶 {t('howToGuide.repeatableSections.useCase3')}</p>
                        <p>• 🔄 {t('howToGuide.repeatableSections.useCase4')}</p>
                        <p>• 📦 {t('howToGuide.repeatableSections.useCase5')}</p>
                      </div>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.repeatableSections.howItWorks')}</h3>
                    <div className="space-y-4 text-gray-700 ml-6">
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">1. {t('howToGuide.repeatableSections.howStep1Title')}</p>
                        <p className="ml-4">{t('howToGuide.repeatableSections.howStep1Desc')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">2. {t('howToGuide.repeatableSections.howStep2Title')}</p>
                        <p className="ml-4">{t('howToGuide.repeatableSections.howStep2Desc')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">3. {t('howToGuide.repeatableSections.howStep3Title')}</p>
                        <p className="ml-4">{t('howToGuide.repeatableSections.howStep3Desc')}</p>
                      </div>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                    <p className="text-green-800 font-semibold">✅ {t('howToGuide.repeatableSections.successTitle')}</p>
                  </div>
                </div>
              )}

              {/* Control Access to Checks Tab */}
              {webSubTab === 'control-access' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.controlAccess.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/NEOKryl5-3o"
                        title={t('howToGuide.controlAccess.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.controlAccess.intro')}</p>

                  {/* Step 1: Create a New Check */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.controlAccess.step1Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.controlAccess.step1Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/access-control-create-check.png"
                        alt={t('howToGuide.controlAccess.step1Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 2: Open Form Access Control */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.controlAccess.step2Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.controlAccess.step2Desc')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/access-control-enable.png"
                        alt={t('howToGuide.controlAccess.step2Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Step 3: Choose Who Can Access */}
                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.controlAccess.step3Title')}
                    </h3>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.controlAccess.step3Desc')}</p>
                    <ul className="space-y-2 text-gray-700 ml-10 mb-4">
                      <li>• {t('howToGuide.controlAccess.step3AllUsers')}</li>
                      <li>• {t('howToGuide.controlAccess.step3SpecificUsers')}</li>
                      <li>• {t('howToGuide.controlAccess.step3SpecificGroups')}</li>
                    </ul>
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.controlAccess.step3Note')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/access-control-options.png"
                        alt={t('howToGuide.controlAccess.step3Alt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Additional Info */}
                  <section className="mb-8">
                    <p className="text-gray-700 mb-4 ml-6">{t('howToGuide.controlAccess.editNote')}</p>
                    <div className="bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shadow-sm ml-6">
                      <img
                        src="/assets/guide/access-control-form-actions.png"
                        alt={t('howToGuide.controlAccess.editAlt')}
                        className="w-full h-auto"
                      />
                    </div>
                  </section>

                  {/* Success Message */}
                  <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                    <p className="text-green-800 font-semibold">✅ {t('howToGuide.controlAccess.successTitle')}</p>
                  </div>
                </div>
              )}

              {/* Policies, Procedures and Knowledge Hub Tab */}
              {webSubTab === 'policies-knowledge-hub' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.newFeatures.policies.title', 'Policies, Procedures and Knowledge Hub')}</h2>
                  <p className="text-gray-700 mb-6">
                    {t('howToGuide.newFeatures.policies.intro', 'Use Policies & Procedures to control documents, assign staff sign-off, add assessments, and keep a full audit trail. The Knowledge Hub brings policy versions, training records, compliance status, assessment submissions, and AI policy search into one place.')}
                  </p>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.newFeatures.policies.uploadTitle', 'Upload a controlled document')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.policies.upload1', 'Go to Policies & Procedures from the dashboard or navigation.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.upload2', 'Select Upload controlled document and add the title, description, category, tags, review interval, and expiry date.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.upload3', 'Upload the policy file. Supported formats include PDF, Word, Excel, PowerPoint, images, and other common document formats.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.upload4', 'Assign the policy to individual users, roles, or groups so only the right staff are asked to read and sign it.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.newFeatures.policies.versionTitle', 'Manage versions and review dates')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.policies.version1', 'Each upload is stored as a controlled version so the latest document is clear and previous versions remain available for audit.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.version2', 'Use review intervals and expiry dates to keep policies current.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.version3', 'When a new version is released, staff can be asked to re-read, complete the assessment again, and provide a fresh signature.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.newFeatures.policies.assessmentTitle', 'Add assessments and AI-generated questions')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.policies.assessment1', 'Open the policy assessment builder and switch Enabled on.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.assessment2', 'Set the pass threshold and choose whether a pass is required before sign-off is accepted.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.assessment3', 'Generate a policy summary first for larger documents. The summary gives the AI a smaller, cleaner source to generate focused questions from.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.assessment4', 'Use AI question generation as a starting point only. Review, edit, and approve every question before publishing.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.assessment5', 'Multiple choice, true/false, and short answer questions can be used. Short answers are kept for audit and manual review.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">4.</span> {t('howToGuide.newFeatures.policies.recordsTitle', 'Track staff sign-off and training records')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.policies.records1', 'Staff open the assigned policy, read the document, complete any assessment, and sign to confirm they understand it.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.records2', 'BuildMyChecks records the user, timestamp, signature, policy version, assessment score, pass percentage, and completion status.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.records3', 'Export training records when evidence is needed for audits, inspections, or internal compliance reviews.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">5.</span> {t('howToGuide.newFeatures.policies.knowledgeTitle', 'Use the Knowledge Hub')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.policies.knowledge1', 'Open Knowledge Hub to view the document control index, compliance overview, training records, and assessment submissions.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.knowledge2', 'Drill into a policy to review versions, assignments, sign-offs, scores, and audit activity.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.knowledge3', 'Use filters to find pending, completed, failed, overdue, expired, or draft records.')}</p>
                      <p>- {t('howToGuide.newFeatures.policies.knowledge4', 'Ask natural-language questions in the AI policy search panel. The assistant uses generated policy summaries and cites the source document/version, so users do not need to scan full documents every time.')}</p>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                    <p className="text-blue-800 font-semibold">{t('howToGuide.newFeatures.policies.tip', 'Tip: for best AI answers, generate a policy summary after uploading each controlled document.')}</p>
                  </div>
                </div>
              )}

              {/* Split Workflow Tab */}
              {webSubTab === 'split-workflow' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.newFeatures.split.title', 'Split Workflow Inspections')}</h2>
                  <p className="text-gray-700 mb-6">
                    {t('howToGuide.newFeatures.split.intro', 'Split Workflow lets one inspection form move through multiple controlled stages, with each stage assigned to the right user or group. It is useful for checks that need handover, approval, follow-up, review, or department-by-department completion.')}
                  </p>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.newFeatures.split.addTitle', 'Add Split Workflow to a form')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.split.add1', 'Open the form builder and choose Split Workflow from the field types list.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.add2', 'Drag it into the form where the next workflow stage should begin.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.add3', 'Add normal fields before or after each Split Workflow marker. The fields between markers belong to that stage.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.add4', 'Example: Admin fields first, then a Split Workflow marker for User 2, then another marker for User 3.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.newFeatures.split.configureTitle', 'Configure stage properties')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.split.configure1', 'Click the Split Workflow stage in the form canvas to open its field properties.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.configure2', 'Give the stage a clear name such as Supervisor Review, Maintenance Action, or Final Approval.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.configure3', 'Assign the stage to specific users, roles, or groups.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.configure4', 'Choose whether assigned users can view data submitted in previous stages.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.configure5', 'Only enable Repeatable when users should be allowed to add another entry for that workflow stage.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.newFeatures.split.conductTitle', 'Conduct the workflow in order')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.split.conduct1', 'The first assigned user completes the first stage and submits it to the next step.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.conduct2', 'User 2 only sees the inspection in drafts or ready-to-continue once the previous stage has been completed.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.conduct3', 'User 3 only receives it after the admin and User 2 stages are complete.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.conduct4', 'Saved previous stages are locked for later users unless the section visibility settings allow them to view the earlier data.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">4.</span> {t('howToGuide.newFeatures.split.rulesTitle', 'Platform and audit rules')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.split.rules1', 'Inspections created and edited on mobile can continue to be edited on mobile.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.rules2', 'Once an inspection is edited in the web app, it becomes web-only because the web builder supports advanced features that the simplified mobile builder does not.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.rules3', 'Changes after submission are recorded in the audit log with the user, timestamp, and modification details.')}</p>
                      <p>- {t('howToGuide.newFeatures.split.rules4', 'PDF exports include Split Workflow sections and format carried-over data for audit-friendly reporting.')}</p>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                    <p className="text-green-800 font-semibold">{t('howToGuide.newFeatures.split.tip', 'Best practice: test each workflow as the assigned users before publishing it company-wide.')}</p>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              {/* Mobile App Sub-tabs */}
              <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200 pb-4">
                <button
                  onClick={() => setWebSubTab('mobile-getting-started')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-getting-started'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🚀 {t('howToGuide.mobileTabs.gettingStarted')}
                </button>
                <button
                  onClick={() => setWebSubTab('mobile-login-sync')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-login-sync'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🔐 {t('howToGuide.mobileTabs.loginSync')}
                </button>
                <button
                  onClick={() => setWebSubTab('mobile-completing-forms')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-completing-forms'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  ✍️ {t('howToGuide.mobileTabs.completingForms')}
                </button>
                <button
                  onClick={() => setWebSubTab('mobile-syncing-offline')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-syncing-offline'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🔄 {t('howToGuide.mobileTabs.syncingOffline')}
                </button>
                <button
                  onClick={() => setWebSubTab('mobile-admin-tools')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-admin-tools'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🛠️ {t('howToGuide.mobileTabs.adminTools')}
                </button>
                <button
                  onClick={() => setWebSubTab('mobile-creating-checks')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-creating-checks'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  📝 {t('howToGuide.mobileTabs.creatingChecks')}
                </button>
                <button
                  onClick={() => setWebSubTab('mobile-policies-ai')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-policies-ai'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  POL {t('howToGuide.mobileTabs.policiesAi', 'Policies & Ask AI')}
                </button>
                <button
                  onClick={() => setWebSubTab('mobile-repeatable-sections')}
                  className={`px-6 py-2 font-semibold rounded-lg transition-colors ${
                    webSubTab === 'mobile-repeatable-sections'
                      ? 'bg-primary text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  🔁 {t('howToGuide.mobileTabs.repeatableSections')}
                </button>
              </div>

              {/* Getting Started Tab */}
              {webSubTab === 'mobile-getting-started' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.mobileGettingStarted.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/b_U5TSE_v2M"
                        title={t('howToGuide.mobileGettingStarted.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      {t('howToGuide.mobileGettingStarted.downloadTitle')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>• {t('howToGuide.mobileGettingStarted.downloadIOS')}</p>
                      <p>• {t('howToGuide.mobileGettingStarted.downloadAndroid')}</p>
                      <p>• {t('howToGuide.mobileGettingStarted.downloadSearch')}</p>
                      <p>• {t('howToGuide.mobileGettingStarted.downloadInstall')}</p>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                    <p className="text-blue-800 font-semibold">📱 {t('howToGuide.mobileGettingStarted.appStoreNote')}</p>
                  </div>
                </div>
              )}

              {/* Login & Sync Tab */}
              {webSubTab === 'mobile-login-sync' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.mobileLoginSync.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/YZoj200_iKQ"
                        title={t('howToGuide.mobileLoginSync.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>

                  <section className="mb-8">
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>• {t('howToGuide.mobileLoginSync.item1')}</p>
                      <p>• {t('howToGuide.mobileLoginSync.item2')}</p>
                      <p>• {t('howToGuide.mobileLoginSync.item3')}</p>
                      <p>• {t('howToGuide.mobileLoginSync.item4')}</p>
                    </div>
                  </section>
                </div>
              )}

              {/* Completing Forms Tab */}
              {webSubTab === 'mobile-completing-forms' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.mobileCompletingForms.heading')}</h2>

                  <section className="mb-8">
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>• {t('howToGuide.mobileCompletingForms.item1')}</p>
                      <p>• {t('howToGuide.mobileCompletingForms.item2')}</p>
                      <p>• {t('howToGuide.mobileCompletingForms.item3')}</p>
                      <p>• {t('howToGuide.mobileCompletingForms.item4')}</p>
                      <p>• {t('howToGuide.mobileCompletingForms.item5')}</p>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                    <p className="text-blue-800">💡 {t('howToGuide.mobileCompletingForms.tip')}</p>
                  </div>
                </div>
              )}

              {/* Syncing & Offline Mode Tab */}
              {webSubTab === 'mobile-syncing-offline' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.mobileSyncingOffline.heading')}</h2>

                  <section className="mb-8">
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>• {t('howToGuide.mobileSyncingOffline.item1')}</p>
                      <p>• {t('howToGuide.mobileSyncingOffline.item2')}</p>
                      <p>• {t('howToGuide.mobileSyncingOffline.item3')}</p>
                      <p>• {t('howToGuide.mobileSyncingOffline.item4')}</p>
                      <p>• {t('howToGuide.mobileSyncingOffline.item5')}</p>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                    <p className="text-green-800 font-semibold">✅ {t('howToGuide.mobileSyncingOffline.successTitle')}</p>
                  </div>
                </div>
              )}

              {/* Admin Tools Tab */}
              {webSubTab === 'mobile-admin-tools' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.mobileAdminTools.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/YTl8sZu8hBc"
                        title={t('howToGuide.mobileAdminTools.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>

                  <p className="text-gray-700 mb-6">{t('howToGuide.mobileAdminTools.intro')}</p>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.mobileAdminTools.featuresTitle')}</h3>
                    <div className="space-y-4 text-gray-700 ml-6">
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">📊 {t('howToGuide.mobileAdminTools.viewReportsTitle')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.viewReportsItem1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.viewReportsItem2')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.viewReportsItem3')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">✅ {t('howToGuide.mobileAdminTools.approveTitle')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.approveItem1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.approveItem2')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.approveItem3')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">👥 {t('howToGuide.mobileAdminTools.manageUsersTitle')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.manageUsersItem1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.manageUsersItem2')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.manageUsersItem3')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">🔧 {t('howToGuide.mobileAdminTools.remediationTitle')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.remediationItem1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.remediationItem2')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileAdminTools.remediationItem3')}</p>
                      </div>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                    <p className="text-blue-800">💡 {t('howToGuide.mobileAdminTools.adminNote')}</p>
                  </div>
                </div>
              )}

              {/* Creating Checks Tab */}
              {webSubTab === 'mobile-creating-checks' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.mobileCreatingChecks.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/xxL8rax95Do"
                        title={t('howToGuide.mobileCreatingChecks.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>

                  <p className="text-gray-700 mb-6">{t('howToGuide.mobileCreatingChecks.intro')}</p>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.mobileCreatingChecks.howToTitle')}</h3>
                    <div className="space-y-4 text-gray-700 ml-6">
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">{t('howToGuide.mobileCreatingChecks.mobileStep1Title')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep1Item1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep1Item2')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">{t('howToGuide.mobileCreatingChecks.mobileStep2Title')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep2Item1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep2Item2')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep2Item3')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">{t('howToGuide.mobileCreatingChecks.mobileStep3Title')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep3Item1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep3Item2')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep3Item3')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep3Item4')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">{t('howToGuide.mobileCreatingChecks.mobileStep4Title')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep4Item1')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep4Item2')}</p>
                        <p className="ml-4">• {t('howToGuide.mobileCreatingChecks.mobileStep4Item3')}</p>
                      </div>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                    <p className="text-yellow-800">⚠️ {t('howToGuide.mobileCreatingChecks.tip')}</p>
                  </div>
                </div>
              )}

              {/* Mobile Policies and AI Search Tab */}
              {webSubTab === 'mobile-policies-ai' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.newFeatures.mobilePoliciesAi.title', 'Policies and Ask AI on Mobile')}</h2>
                  <p className="text-gray-700 mb-6">
                    {t('howToGuide.newFeatures.mobilePoliciesAi.intro', 'The mobile app keeps policy sign-off simple for users in the field. Staff can read assigned documents, complete assessments, sign acknowledgements, and ask policy questions without needing the full web Knowledge Hub.')}
                  </p>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">1.</span> {t('howToGuide.newFeatures.mobilePoliciesAi.openTitle', 'Open assigned policies')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.open1', 'Open the mobile app and go to Policies.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.open2', 'Policies assigned to the logged-in user, their role, or their groups will appear in the list.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.open3', 'Items that need attention show as pending, overdue, expired, failed, or ready to sign.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">2.</span> {t('howToGuide.newFeatures.mobilePoliciesAi.signTitle', 'Complete sign-off')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.sign1', 'Open the policy document and read the controlled version shown on screen.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.sign2', 'If an assessment is attached, answer the questions and meet the required pass threshold if one has been set.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.sign3', 'Add the required signature to confirm the document has been read and understood.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.sign4', 'BuildMyChecks stores the policy version, timestamp, score, pass percentage, and signature for training records.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">3.</span> {t('howToGuide.newFeatures.mobilePoliciesAi.askTitle', 'Ask policy questions on the go')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.ask1', 'Use the Ask policies card at the top of the Policies screen.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.ask2', 'Type a natural-language question such as What PPE do I need for this task? or When should this procedure be escalated?')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.ask3', 'The AI searches generated policy summaries for policies assigned to that user and returns a short answer with source documents.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.ask4', 'Tap a source to open the policy and check the controlled document directly.')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <span className="text-primary">4.</span> {t('howToGuide.newFeatures.mobilePoliciesAi.troubleshootingTitle', 'Troubleshooting')}
                    </h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.troubleshooting1', 'If the AI cannot answer, ask an admin to generate or refresh the policy summary in the web app.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.troubleshooting2', 'AI search needs a connection because answers are generated securely through Firebase functions.')}</p>
                      <p>- {t('howToGuide.newFeatures.mobilePoliciesAi.troubleshooting3', 'The full Knowledge Hub dashboard, document control index, and training record exports remain web app features for admins.')}</p>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                    <p className="text-blue-800 font-semibold">{t('howToGuide.newFeatures.mobilePoliciesAi.tip', 'Tip: mobile AI search is designed for quick guidance, not replacing the controlled policy document.')}</p>
                  </div>
                </div>
              )}

              {/* Repeatable Sections Tab */}
              {webSubTab === 'mobile-repeatable-sections' && (
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('howToGuide.mobileRepeatableSections.heading')}</h2>
                  
                  {/* Video Section */}
                  <div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
                    <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      📺 {t('howToGuide.watchVideo')}
                    </h3>
                    <div className="aspect-video w-full">
                      <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/kxONO_RZOZw"
                        title={t('howToGuide.mobileRepeatableSections.videoTitle')}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">{t('howToGuide.mobileRepeatableSections.intro')}</p>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.mobileRepeatableSections.whatYouLearn')}</h3>
                    <div className="space-y-3 text-gray-700 ml-6">
                      <p>• {t('howToGuide.mobileRepeatableSections.learn1')}</p>
                      <p>• {t('howToGuide.mobileRepeatableSections.learn2')}</p>
                      <p>• {t('howToGuide.mobileRepeatableSections.learn3')}</p>
                      <p>• {t('howToGuide.mobileRepeatableSections.learn4')}</p>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.mobileRepeatableSections.useCasesTitle')}</h3>
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded ml-6">
                      <p className="text-gray-700 mb-2"><strong>{t('howToGuide.mobileRepeatableSections.useCasesIntro')}</strong></p>
                      <div className="space-y-2 text-gray-700 ml-4 mt-3">
                        <p>• 🧯 {t('howToGuide.mobileRepeatableSections.useCase1')}</p>
                        <p>• 🔍 {t('howToGuide.mobileRepeatableSections.useCase2')}</p>
                        <p>• 🚶 {t('howToGuide.mobileRepeatableSections.useCase3')}</p>
                        <p>• 🔄 {t('howToGuide.mobileRepeatableSections.useCase4')}</p>
                        <p>• 📦 {t('howToGuide.mobileRepeatableSections.useCase5')}</p>
                      </div>
                    </div>
                  </section>

                  <section className="mb-8">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.mobileRepeatableSections.usingTitle')}</h3>
                    <div className="space-y-4 text-gray-700 ml-6">
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">1. {t('howToGuide.mobileRepeatableSections.mobileStep1Title')}</p>
                        <p className="ml-4">{t('howToGuide.mobileRepeatableSections.mobileStep1Desc')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">2. {t('howToGuide.mobileRepeatableSections.mobileStep2Title')}</p>
                        <p className="ml-4">{t('howToGuide.mobileRepeatableSections.mobileStep2Desc')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">3. {t('howToGuide.mobileRepeatableSections.mobileStep3Title')}</p>
                        <p className="ml-4">{t('howToGuide.mobileRepeatableSections.mobileStep3Desc')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">4. {t('howToGuide.mobileRepeatableSections.mobileStep4Title')}</p>
                        <p className="ml-4">{t('howToGuide.mobileRepeatableSections.mobileStep4Desc')}</p>
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800 mb-2">5. {t('howToGuide.mobileRepeatableSections.mobileStep5Title')}</p>
                        <p className="ml-4">{t('howToGuide.mobileRepeatableSections.mobileStep5Desc')}</p>
                      </div>
                    </div>
                  </section>

                  <div className="ml-6 mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded">
                    <p className="text-green-800 font-semibold">✅ {t('howToGuide.mobileRepeatableSections.successTitle')}</p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Help & Support */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <h3 className="text-2xl font-semibold text-gray-800 mb-4">{t('howToGuide.needHelp')}</h3>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => navigate('/contact')}
              className="px-6 py-3 bg-primary hover:bg-red-700 text-white rounded-lg font-semibold transition-colors"
            >
              📧 {t('howToGuide.contactSupport')}
            </button>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-semibold transition-colors"
            >
              🏠 {t('howToGuide.backToHome')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ----------------------------------------------------------------------------------------------
//  Build My Checks (c) 2025 Gareth Morgan - BuildMyChecks.co.uk
//  Solely designed, developed, and maintained by Gareth Morgan.
//  All intellectual property rights reserved.
//  No liability is accepted for unauthorised use, modification, deployment, or maintenance.
// ----------------------------------------------------------------------------------------------
